module.exports = __webpack_public_path__ + "static/media/decoration-gray-bottom-2.26c7d1b5.svg";